import { Directive, OnInit, OnDestroy, Injectable, Inject, forwardRef, Input } from '@angular/core';
import { DataBindingDirective, GridComponent } from '@progress/kendo-angular-grid';
import { Subscription } from 'rxjs';
import {  RegistrierungenDataService } from '../data-services';
import { ODataBindingDirective } from './core/o-data-binding-directive';
import { ODataEntitySetResource } from 'angular-odata';

@Injectable()
@Directive({
  selector: '[registrierungenDataBinding]'
})
export class RegistrierungenDataDirective  extends ODataBindingDirective  {

  @Input('registrierungenDataBinding') query:  ODataEntitySetResource<any>;
    
    constructor(@Inject(forwardRef(() =>RegistrierungenDataService)) dataService: RegistrierungenDataService, @Inject(forwardRef(() => GridComponent))  grid: GridComponent) {
        super(dataService,grid);
    }
    public ngOnChanges( c: any ) : void {
 
        console.log( "Base-Query:", this.query);
        this.rebind();
    }
}
